module.exports = __webpack_public_path__ + "img/504177440.464d99cb.jpg";